import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { LogService, IUrl } from '@medlogic/shared/shared-interfaces';

@Component({
  selector: 'ui-bottom-sheet',
  templateUrl: './ui-bottom-sheet.component.html',
  styleUrls: ['./ui-bottom-sheet.component.css']
})
export class UiBottomSheetComponent {

  urls: IUrl[];

  constructor(
    private log: LogService,
    private bottomSheetRef: MatBottomSheetRef<UiBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: any // { urls: Array<IUrl> }
  ) {
    this.urls = data.urls;
  }

  openLink(event: MouseEvent, url: IUrl): void {
    try {
      this.bottomSheetRef.dismiss(url);
      event.preventDefault();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'openLink', error.message);
    }
  }


}
